export type LegacyAdminUsageProduct = '월사용료' | '문자사용료' | '스토리지'

export interface LegacyAdminUsageRow {
  id: string
  requestedAt: string
  brand: string
  group: string
  price: number
  supply: number
  vat: number
  product: LegacyAdminUsageProduct
  detail: string
  paidAt: string
  medium: string
  status: string
  paymentRef: string
  receipt: string
  agency: string
}

export const legacyAdminUsageBrands = ['Mock 브랜드 전체', 'Mock 브랜드 01', 'Mock 브랜드 02']
export const legacyAdminUsageGroups = ['Mock 그룹 전체', 'Mock 그룹 01', 'Mock 그룹 02']
export const legacyAdminUsageStaff = ['선택', 'Mock 담당자 01', 'Mock 담당자 02', 'Mock 담당자 03']

export const legacyAdminUsageRows: LegacyAdminUsageRow[] = [
  {
    id: 'mock-payment-001',
    requestedAt: '2026-08-20 09:30:00',
    brand: 'Mock 브랜드 01',
    group: 'Mock 그룹 01',
    price: 110000,
    supply: 100000,
    vat: 10000,
    product: '월사용료',
    detail: 'Mock 월 정기 이용료',
    paidAt: '2026-08-20 09:30:04',
    medium: '카드',
    status: '결제완료',
    paymentRef: 'Mock 카드 ****-0000',
    receipt: 'Mock 영수증',
    agency: 'Mock PG',
  },
]
